var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5H10.5L10.14 8M10.14 8L9 17.5H25L28.5 8H10.14ZM3 9.5H7",
    "stroke-": "current",
    strokeWidth: 2.5,
    strokeMiterlimit: 2.3662,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13H11",
    "stroke-": "current",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5H9",
    "stroke-": "current",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7688 23.3089C11.021 24.6043 9.73105 24.8766 9.00747 24.4588C8.28389 24.041 7.87469 22.7878 8.62259 21.4924C9.37049 20.197 10.6604 19.9248 11.384 20.3426C12.1076 20.7603 12.5167 22.0135 11.7688 23.3089Z",
    "stroke-": "current",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7688 23.3089C23.021 24.6043 21.731 24.8766 21.0075 24.4588C20.2839 24.041 19.8747 22.7878 20.6226 21.4924C21.3705 20.197 22.6604 19.9248 23.384 20.3426C24.1076 20.7603 24.5167 22.0135 23.7688 23.3089Z",
    "stroke-": "current",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.1799H23",
    "stroke-": "current",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.aaa332f8f1537ad6d6afbd8bf1dcb7f6.svg";
export { ForwardRef as ReactComponent };